<template>
  <v-dialog v-model="dialog" persistent width="710">
    <v-card color="white" tile flat class="pb-4">
      <v-card-title class="dialog-header-title">
        {{ title == null ? "Create quotation for:" : title }}
        <span class="title px-2">{{
          selectedCustomer != null ? selectedCustomer.name : ""
        }}</span>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="pt-2">
        <v-row no-gutters>
          <v-col cols="9">
            <v-autocomplete
              dense
              solo
              :items="sortedCustomerList"
              v-model="selectedCustomer"
              class="form-control font-weight-bold rounded-0"
              item-text="label"
              return-object
              clearable
            ></v-autocomplete>
          </v-col>

          <v-col class="d-flex justify-content-end">
            <v-btn
              @click="onSelect"
              tile
              color="primary"
              class="font-weight-bold text-button"
              depressed
              :disabled="selectedCustomer == null"
              >CONTINUE</v-btn
            >
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import constant from "@/const";

export default {
  props: ["dialog", "title", "is_edit"],

  data() {
    return {
      customerList: [],
      selectedCustomer: null,
    };
  },

  created() {
    this.customerList = [];
    this.selectedCustomer = null;
    if (this.$root.is_admin) {
      this.onInit();
    }
  },

  watch: {
    dialog: function () {
      if (this.dialog) {
        this.customerList = [];
        this.selectedCustomer = null;
        if (this.$root.is_admin) {
          this.onInit();
        }
      } else {
        this.selectedCustomer = null;
      }
    },
  },

  methods: {
    onInit() {
      var response = null;
      this.$root.blockUImsg = "Loading company list...";
      this.$root.blockUIshow = true;

      this.$https
        .get("/api/company/list")
        .then((resp) => (response = resp))
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          if (response != null && response.data.status == constant.RESPONSE_STATUS_OK) {
            // if is_edit is false, then set the default company to General Inquiry (AFC-0232)
            if (!this.is_edit) {
              // set the default company to General Inquiry (AFC-0232)
              for (let i = 220; i < response.data.data.length; i++) {
                const element = response.data.data[i];

                if (element.company_id == constant.GENERAL_INQUIRY_COMPANY_ID) {
                  this.selectedCustomer = element;
                  break;
                }
              }
            }

            this.customerList = response.data.data;
          } else {
            console.log("Error loading company list", response);
          }

          this.$root.blockUIshow = false;
        });
    },

    onSelect() {
      this.$emit("dialog-close", this.selectedCustomer);
    },

    /*
        onClose(){
            this.$emit('dialog-close', null)
        },
        */

    getRowBackgroundColor: function (item) {
      var color = "transparent";

      if (this.selectedCustomer != null && this.selectedCustomer == item) {
        color = "#80CBC4";
      }

      return color;
    },
  },

  computed: {
    sortedCustomerList: function () {
      return this.customerList.sort(function (a, b) {
        return a.label.localeCompare(b.label);
      });
    },
  },
};
</script>

<style>
/* .modal-mask {
  position: fixed;
  z-index: 11000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 800px;
  margin: 0px auto;
  padding: 20px 20px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

.modal-list {
  height: 75%;
  overflow: auto;
}

.toolbar {
  height: 50px;
  line-height: 50px;
}

.sub-heading {
  font-weight: normal;
  font-size: 100%;
}

.dialog-customer-list {
  z-index: 10005 !important;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif !important;
} */
</style>
